import {MDBCollapse, MDBSideNav, MDBSideNavItem, MDBSideNavLink, MDBSideNavMenu} from "mdbreact"
import {useEffect, useState} from "react"
import {Link, useLocation} from "react-router-dom"
import {appConfig} from "../Config"
import {setSelectedNavAction} from "../containers/App/appSlice"
import {ShowForPermission} from "../Permissions"
import {RootState} from "../rootReducer"
import {useAppDispatch, useAppSelector} from "../store"
const SideNavigation = ({triggerOpening, onLinkClick}: {triggerOpening: boolean; onLinkClick: any}) => {
    const roles = useAppSelector((state: RootState) => state.containers.users.roles)

    const appRoles = {
        permission: roles?.map(x => x.id) ?? [],
    }
    const adminRoles = {
        permission: [appConfig.globalAdminRoleId, appConfig.regionalAdminRoleId],
    }

    const location = useLocation()
    const dispatch = useAppDispatch()
    const selectedNav = useAppSelector((state: RootState) => state.application.selectedNav)

    const [collapseMOT, setcollapseMOT] = useState(true)
    const [collapseSettings, setcollapseSettings] = useState(true)
    const [collapseAdministration, setcollapseAdministration] = useState(true)

    const setNavItemSelected = (path: string) => {
        dispatch(setSelectedNavAction(path.toString()))
        onLinkClick()
    }

    useEffect(() => {
        dispatch(setSelectedNavAction(location.pathname))
    }, [])

    const rSNL = (to: string, text: string) => {
        return (
            <Link to={to}>
                <MDBSideNavLink
                    onClick={() => {
                        setNavItemSelected(to)
                    }}
                    active={selectedNav === to}
                >
                    {text}
                </MDBSideNavLink>
            </Link>
        )
    }

    return (
        <MDBSideNav closeOnEsc={false} backdrop={false} mode="side" isOpen={triggerOpening}>
            <MDBSideNavMenu>
                <ShowForPermission {...appRoles}>
                    <MDBSideNavItem>{rSNL("/", "Dashboard")}</MDBSideNavItem>
                    <MDBSideNavItem>
                        <MDBSideNavLink
                            shouldBeExpanded={collapseMOT}
                            onClick={() => {
                                setcollapseMOT(!collapseMOT)
                            }}
                            icon="angle-down"
                        >
                            Manage MOT
                        </MDBSideNavLink>
                        <MDBCollapse show={collapseMOT}>
                            {rSNL("/overview", "Overview")}
                            {rSNL("/planner", "Planner")}
                            {rSNL("/mot-bookings", "Bookings")}
                            {rSNL("/pass-rates-summary", "Pass Rates Summary")}
                            {rSNL("/pass-rates-details", "Pass Rates Details")}
                            {rSNL("/reports", "Reports")}
                            {rSNL("/mot", "MOT History")}
                            {rSNL("/activities", "Activities")}
                        </MDBCollapse>
                    </MDBSideNavItem>
                </ShowForPermission>
                <ShowForPermission {...appRoles}>
                    <MDBSideNavItem>
                        <MDBSideNavLink
                            shouldBeExpanded={collapseSettings}
                            onClick={() => {
                                setcollapseSettings(!collapseSettings)
                            }}
                            icon="angle-down"
                        >
                            Settings
                        </MDBSideNavLink>
                        <MDBCollapse show={collapseSettings}>
                            {rSNL("/fees", "Test Packages")}
                            {rSNL("/custom-prices", "Custom Pricing")}
                            {rSNL("/test-stations", "Test Stations")}
                            {rSNL("/customers", "Customers")}
                            {rSNL("/vehicles", "Vehicles")}
                            {rSNL("/dvsa-schedules", "DVSA Schedules")}
                            {rSNL("/dvsa-fee", "DVSA Fee")}
                            {rSNL("/dvsa-tests", "DVSA Tests")}
                        </MDBCollapse>
                    </MDBSideNavItem>
                    <ShowForPermission {...adminRoles}>
                        <MDBSideNavItem>
                            <MDBSideNavLink
                                shouldBeExpanded={collapseAdministration}
                                onClick={() => {
                                    setcollapseAdministration(!collapseAdministration)
                                }}
                                icon="angle-down"
                            >
                                Administration
                            </MDBSideNavLink>
                            <MDBCollapse show={collapseAdministration}>
                                {rSNL("/regions-and-dealers", "Regions & Dealers")}
                                {rSNL("/users", "Users")}
                            </MDBCollapse>
                        </MDBSideNavItem>
                    </ShowForPermission>
                </ShowForPermission>
                <ShowForPermission {...adminRoles}>
                    <MDBSideNavItem>{rSNL("/access-policies", "Access Policies")}</MDBSideNavItem>
                </ShowForPermission>
            </MDBSideNavMenu>
        </MDBSideNav>
    )
}

export default SideNavigation
